export default __webpack_public_path__ + "static/media/precommande-doudoux.17c54515.png";